import { type ReduxStateShared } from '~shared/types';

export const getIsEditingExistingOrder = (state: ReduxStateShared) => state.ui.cart.isEditingOrder;
export const getIsSplitPaymentEnabled = (state: ReduxStateShared) => state.ui.cart.isSplitPaymentEnabled;
export const getDidAttemptOrderUpdate = (state: ReduxStateShared) => state.ui.cart.didAttemptOrderUpdate;
export const getScheduleableSameDayFee = (state: ReduxStateShared) => state.ui.cart.scheduleableSameDayFee;
